<mat-sidenav-container>
    <mat-sidenav
      class="admin-main-sidenav fixed-sidenav clear-sidenav-background"
      [class.beta-sidenav-safari-main-menu]="useMainMenuOnSafari"
      #mainSidenav
      [mode]="'side'"
      [opened]="true"
      [disableClose]="true"
      position="start"
      (openedStart)="openedStart()"
      (openedChange)="mainSidenavToggled($event)"
    >
      <!-- Same as beta layout: keep both mounted so Safari navigation does not tear down the main menu. -->
      <app-main-menu
        [hidden]="!useMainMenuOnSafari"
        [attr.aria-hidden]="!useMainMenuOnSafari"
        [replicateBetaMenuLinks]="true"
      ></app-main-menu>
      <app-beta-menu
        [hidden]="useMainMenuOnSafari"
        [attr.aria-hidden]="useMainMenuOnSafari"
      ></app-beta-menu>
    </mat-sidenav>
  
    <mat-sidenav-content class="admin-main-content">
      <app-top-navbar
        class="admin-top-navbar show-bare-branding"
        mode="condensed"></app-top-navbar>
      <router-outlet></router-outlet>
  
      <app-clarity-menu
        *ngIf="showClarityAndBusinessMenus"
        [fabCorner]="'bottom-right'"
        [openStyle]="'fullscreen'"
        [showReasoningDropdown]="true"
      ></app-clarity-menu>
 
      <app-business-menu
        *ngIf="showClarityAndBusinessMenus && currentScreenSize !== 'small'"
        [fabCorner]="'bottom-right'"
        [openStyle]="'fullscreen'"
        [showReasoningDropdown]="false"
      ></app-business-menu>
 
      <app-doublecoach-menu
        *ngIf="showDoubleCoachMenu && !isMaxWidth1000px"
        [fabCorner]="'bottom-right'"
        [openStyle]="'fullscreen'"
        [showReasoningDropdown]="false"
      ></app-doublecoach-menu>
    </mat-sidenav-content>
  
    <mat-sidenav
      class="admin-alt-sidenav fixed-sidenav"
      #altSidenav
      mode="over"
      opened="false"
      position="end"
      (openedChange)="altSidenavToggled($event)"
    >
      <app-dynamic-menu></app-dynamic-menu>
      <app-clarity-history></app-clarity-history>
    </mat-sidenav>
  </mat-sidenav-container>
  
